var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    _vm._g(
      {
        staticClass: "_check",
        class: _vm._class,
        style: { width: _vm.width, height: _vm.height }
      },
      _vm.__on
    ),
    [
      _c(
        "input",
        _vm._g(
          {
            ref: "_in",
            attrs: {
              type: "checkbox",
              id: _vm.id,
              name: _vm.name,
              required: _vm.required,
              disabled: _vm.disabled,
              inert: _vm.inert,
              tabindex: _vm.inert ? -1 : _vm.tabindex
            },
            domProps: { value: _vm.val },
            on: { change: _vm.changed }
          },
          _vm.__on
        )
      ),
      _c(
        "span",
        {
          staticClass: "_cbc",
          class: ((_obj = {}), (_obj["_" + _vm.tone] = _vm.tone), _obj),
          attrs: { "aria-hidden": "true" }
        },
        [_vm._v("‌")]
      ),
      _vm.$slots.default
        ? _c("span", { staticClass: "_cbl" }, [_vm._t("default")], 2)
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }